import { OreButton, OreCardContainer, OreCardWrapper, OreDivider, OreStack } from "@edenredespana/oreneta"
import { FormProvider } from "react-hook-form"
import { IndentifyForm, useRegisterController } from "../hooks"
import { CreateAccountIdentifyForm } from "./"
import { createRegisterRepository } from "@/Account/infrastructure/ApiRegisterRepository"
import { useNavigate } from "react-router-dom"
import { openNavigationRoutes } from "@/Shared/ui/routers"
import { formTranslation } from "@/Shared/ui/sharedTranslation"
import { useTranslation } from "react-i18next"
import { IndentifyAffiliateErrorModal } from "../organisms"
import { useState } from "react"
import { useLoader } from "@/Shared/ui/loader"
import { useRateLimitedCountdown } from "@/Shared/ui/hooks"
import { HttpMethod } from "@/Shared/domain"
import { registerVerifyIdentity } from "@/Shared/infrastructure/endpoints"
import { registerResponseErrors } from "@/Shared/domain/enum/responseErrors"

export const RegisterStepOne = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { startLoading, stopLoading } = useLoader()
  const { identifyForm, verifyIdentity } = useRegisterController(createRegisterRepository())
  const { formState: { isValid }, watch } = identifyForm
  const [isErrorMessageOpen, setIsErrorMessageOpen] = useState<boolean>(false)

  const {
    formattedMessage,
    startCountdown,
    isBlocked,
    shouldBlockForm,
  } = useRateLimitedCountdown({
    messageTemplate: t(formTranslation.common.validationBlockMessage),
    params: {
      endpointRoute: `${registerVerifyIdentity}`,
      endpointActionName: HttpMethod.POST
    }
  })

  const handleSubmit = async (data: IndentifyForm) => {
    startLoading()
    const response = await verifyIdentity(data)
    stopLoading()

    const {success, error} = response

    if (!success) {
      if (error === registerResponseErrors.alreadyExists) {
        identifyForm.setError("root", { type: "custom" })
        identifyForm.setError("backOfficeCompanyId", { type: "custom" })
      } else {
        setIsErrorMessageOpen(true)
      }

      const mustBlockForm = await shouldBlockForm()
      if (mustBlockForm) {
        startCountdown()
      }
    }
  }

  return (
    <>
      <FormProvider {...identifyForm}>
        <form>
          <OreCardContainer>
            <OreCardWrapper>
              <OreStack space="2xlarge" placeContent="stretch">
                <CreateAccountIdentifyForm isBlocked={isBlocked} errorMessage={formattedMessage} />
              </OreStack>
            </OreCardWrapper>
          </OreCardContainer>

          <OreDivider space="medium" />
          <OreStack direction="row" placeContent="end" space="medium">
            <OreButton
              onClick={() => navigate(openNavigationRoutes.login)}
              size="small"
              category="secondary"
              data-testid="cancel"
            >
              {t(formTranslation.common.buttons.cancel)}
            </OreButton>
            <OreButton
              disabled={!isValid || isBlocked}
              type="submit"
              onClick={identifyForm.handleSubmit(handleSubmit)}
              size="small"
              category="primary"
              data-testid="signUp"
            >
              {t(formTranslation.common.buttons.continue)}
            </OreButton>
          </OreStack>
        </form>
      </FormProvider>
      <IndentifyAffiliateErrorModal
        isErrorMessageOpen={isErrorMessageOpen}
        setOpen={setIsErrorMessageOpen}
      />

    </>
  )
}